import { emptyFn } from './utils'
export class InputAutoCompleteIndexedDB {
  constructor(opt) {
    if (!opt) return
    this.openCallabck = opt.open || emptyFn
    this.open(opt)
  }

  /**
  * @param：
  * @Description：统一对数据库开启，使用回调
  */
  initdb(opt) {
    if (!opt) { return }
    this.indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB
    if (!this.indexedDB) { return }
    return new Promise((resolve, reject) => {
      const request = this.indexedDB.open(opt.dbname, opt.version)
      request.onerror = function (e) {
        reject(e)
      }
      request.onsuccess = (e) => {
        this.db = e.target.result
        this.openCallabck()
        resolve(this.db)
      }
      request.onupgradeneeded = (e) => {
        this.db = e.target.result
        resolve(this.db)
      }
    })
  }

  /**
  * @param：{
  * dbname:数据库名称,
  * version:数据库版本号,
  * stores:表信息数组
  * [
  *   {
  *    storename:表名,keys:主键
  *     [{
  *       name:主键名称,
  *       unique:是否可重复
  *     }]
  *   }
  * ],
  * delstore:表名数组}
  * @Description：数据库开启/创建表/删除表
  */
  open(opt) {
    this.initdb(opt).then(() => {
      if (opt.stores && opt.stores.length) {
        opt.stores.forEach((store) => {
          if (!this.db.objectStoreNames.contains(store.storename)) {
            // 如果表格不存在，创建一个新的表格（keyPath，主键 ； autoIncrement,是否自增），会返回一个对象（objectStore）
            const objectStore = this.db.createObjectStore(store.storename, {
              keyPath: opt.keyPath || 'id',
              autoIncrement: true
            })
            // 指定可以被索引的字段，unique字段是否唯一
            if (store.keys && store.keys.length) {
              store.keys.forEach((key) => {
                objectStore.createIndex(key.name, key.name, {
                  unique: key.unique
                })
              })
            }
          }
        })
      }
    }).catch(err => {
      console.error('InputAutoCompleteIndexedDB', err)
    })
  }

  /**
  * @param: {storeName:表名， data:添加的数据}
  * @Description：添加数据
  */
  add(opt) {
    return new Promise((resolve, reject) => {
      const request = this.db.transaction([opt.storeName], 'readwrite')
        .objectStore(opt.storeName)
        .add(opt.data)
      request.onsuccess = resolve
      request.onerror = reject
    })
  }

  /**
  * @param：{storeName:表名，key:主键,value:主键值}
  * @Description：删除数据
  */
  delete(opt) {
    return new Promise((resolve, reject) => {
      let request
      const store = this.db.transaction(opt.storeName, 'readwrite')
        .objectStore(opt.storeName)

      if (opt.key) {
        request = store.index(opt.key || 'id')['delete'](opt.value)
      } else {
        request = store['delete'](opt.value)
      }
      request.onsuccess = resolve
      request.onerror = reject
    })
  }

  /**
  * @param：{storeName:表名，key:主键,value:主键值}
  * @Description：获取数据
  */
  get(opt) {
    return new Promise((resolve, reject) => {
      let request
      const store = this.db.transaction(opt.storeName, 'readwrite')
        .objectStore(opt.storeName)
      if (opt.key) {
        request = store.index(opt.key).get(opt.value)
      } else {
        request = store.get(opt.value)
      }
      request.onsuccess = (e) => {
        resolve(request.result)
      }
      request.onerror = reject
    })
  }

  /**
  * @param：查询某个表所有数据
  * @Description：获取数据
  */
  getAll(opt) {
    return new Promise((resolve, reject) => {
      let request
      const store = this.db.transaction(opt.storeName, 'readwrite').objectStore(opt.storeName)
      request = store.getAll()
      request.onsuccess = (e) => {
        resolve(request.result)
      }
      request.onerror = reject
    })
  }

  /**
  * @param：{storeName:表名 key:键值 newData：新数据}
  * @Description：更新数据
  */
  update(opt) {
    return new Promise((resolve, reject) => {
      if (!this.db) {
        return reject(new Error('数据库不存在'))
      }
      let transaction = this.db.transaction(opt.storeName, 'readwrite')

      let request
      const store = transaction.objectStore(opt.storeName)

      if (opt.key) {
        request = store.index(opt.key).get(opt.value)
      } else {
        request = store.get(opt.value)
      }
      request.onsuccess = (e) => {
        const data = e.target.result || {}
        for (const key in opt.data) {
          data[key] = opt.data[key]
        }
        store.put(data)
        resolve(e)
      }
      request.onerror = reject
    })
  }

  /**
  * @param：{delstores:空间名称数组}
  * @Description：删除空间
  */
  deleteStore(opt) {
    if (opt.delstores && opt.delstores.length) {
      opt.delstores.forEach((store) => {
        if (this.db.objectStoreNames.contains(store)) {
          // 如果存在表格，则删除
          this.db.deleteObjectStore(store)
        }
      })
    }
  }

  /**
  * @param：{db:indexedDB对象}
  * @Description：关闭数据库
  */
  closeDB(db) {
    db.close()
  }

  /**
  * @param {name:数据库名称}
  * @Description：删除数据库
  */
  deleteDB(name) {
    this.indexedDB.deleteDatabase(name)
  }
}




// WEBPACK FOOTER //
// ./src/layout/layout/setup/input-autocomplete/indexedDB.js